export const REDUX_GET_USER_SUBJECTS = 'REDUX_GET_USER_SUBJECTS'